import { Pipe, PipeTransform } from '@angular/core';
import dayjs from '@shared/date/dayjs-bootstrap';

@Pipe({
    name: 'durationTime',
    standalone: false
})
export class DurationTimePipe implements PipeTransform {
  transform(value: number, unit: dayjs.ManipulateType = 'seconds'): string {
    return dayjs.duration(value, unit).humanize();
  }
}
